import { H3Event } from "h3";

export const fetchBelajarWajib = async (
  event: H3Event,
  url: string,
  methode: string,
  payload: any
) => {
  const config = useRuntimeConfig();
  const baseUrl = config.public.apiBelajarWajib;
  const fullUrl = `${baseUrl}${url}`;
  const headers = {
    Authorization: "Bearer " + localStorage.getItem("tokenBelajarWajib"),
    "ngrok-skip-browser-warning": "true",
  };
  const res = await $fetch.raw(fullUrl, {
    method: methode as any,
    headers,
    body: payload,
  });
  return res._data;
};
